import { ReactNode } from 'react'
import Sidebar from './Sidebar'

interface MainLayoutProps {
  children: ReactNode
  title?: string
  subtitle?: string
  headerActions?: ReactNode
  showHeader?: boolean
}

export function MainLayout({
  children,
  title,
  subtitle,
  headerActions,
  showHeader = true,
}: MainLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Top Navbar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 pt-[64px]">
        {/* Optional Page Header */}
        {showHeader && (title || subtitle) && (
          <div className="bg-white border-b border-border-light px-8 py-4">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                {title && (
                  <h1 className="text-2xl font-semibold text-text-primary">
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <p className="text-sm text-text-secondary mt-1">{subtitle}</p>
                )}
              </div>
              {headerActions && (
                <div className="flex items-center gap-4">
                  {headerActions}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Content Area */}
        <main className="p-8">
          <div className="max-w-content mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default MainLayout
